import { motion } from "framer-motion";
import clsx from "clsx";

export const BookCover = ({ book, className, interactive = true }) => (
  <motion.div
    data-testid={`book-cover-${book.id}`}
    whileHover={interactive ? { rotateY: 8, rotateZ: -1.5, scale: 1.03 } : undefined}
    transition={{ type: "spring", stiffness: 180, damping: 16 }}
    className={clsx(
      "relative aspect-[2/3] w-full select-none overflow-hidden rounded-[3px] border border-white/15 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.85)]",
      className
    )}
    style={{ background: book.gradient, transformStyle: "preserve-3d", perspective: 800 }}
  >
    <div className="absolute inset-y-0 left-0 w-[7%] border-r border-white/10 bg-black/45" />
    <div
      className="absolute inset-0"
      style={{ background: "radial-gradient(circle at 72% 18%, rgba(255,255,255,0.16), transparent 62%)" }}
    />
    <div
      className="absolute inset-0 opacity-25 mix-blend-overlay"
      style={{ background: `radial-gradient(circle at 30% 85%, ${book.accent}, transparent 55%)` }}
    />
    <div className="absolute inset-0 flex flex-col justify-between p-[8%] pl-[15%]">
      <p className="font-sans text-[9px] font-semibold uppercase tracking-[0.35em] text-white/50">
        {book.tag}
      </p>
      <div>
        <h3 className="font-serif text-[clamp(1.15rem,2.4vw,1.9rem)] font-bold leading-[1.08] text-white/95">
          {book.title}
        </h3>
        <p className="mt-[8%] font-sans text-[9px] uppercase tracking-[0.25em] text-white/60">
          {book.author}
        </p>
      </div>
      <p className="font-sans text-[8px] uppercase tracking-[0.35em] text-white/40">
        Samkhya Publishing
      </p>
    </div>
  </motion.div>
);
